<template>
  <div class="Navbar">
    <nav class="navbar navbar-expand-md navbar-light bg-light rounded fixed-top shadow-sm"
      :class="{ 'mt-4': usuario.id && usuario.idEmpresaSeleccionada != '' && !esModoSinConexion }">
      <div class="container-fluid">
        <!-- LOGO Y BOTóN DE INICIO -->
        <router-link :to="{ name: 'Inicio' }">
          <img src="../../../public/img/riskmann_icono_color.png" alt="" width="42"
            class="d-inline-block align-text-top" id="logo-app-navbar" />
        </router-link>
        <div class="row d-flex align-items-center">
          <div class="col">
            <!-- NOTIFICACIONES -->
            <button v-if="usuario.id" type="button" class="btn btn-primary btn-md position-relative"
              id="btn-notificaciones-navbar" @click="abrirOffCanvas()" :disabled="esModoSinConexion">
              <i class="fas fa-bell"></i>
              <i v-if="usuario.notificaciones === 0"></i>
              <span v-else class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {{ usuario.notificaciones }}
              </span>
            </button>
          </div>
          <div v-if="usuario.id" class="col">
            <!-- BOTÓN DEL PERFIL -->
            <router-link :to="{ name: 'UsuarioMiPerfil' }" :class="{ 'cursor_none': esModoSinConexion }">
              <img class="shadow-sm rounded-pill border border-light" :src="usuario.foto
                ? usuario.foto
                : $store.state.imagenes.defecto.foto
                " alt="" width="42" id="foto-perfil-navbar" />
            </router-link>
          </div>
          <div class="col">
            <!-- BOTÓN DE NAVEGACIÓN -->
            <button id="btn-navbar-app" class="btn btn-primary btn-md" type="button" data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" title="Abrir Menú">
              <i class="fas fa-bars"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
    <Notificaciones v-if="esNotificaciones" @mostrar="cerrarOffCanvas" />
    <!-- LISTA DE NAVEGACIÓN DESPLEGABLE -->
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
      <div class="offcanvas-header border bg-light pe-3 ps-3 pt-2 pb-1">
        <h5 class="offcanvas-title fw-bold fs-6" id="offcanvasExampleLabel">
          <img src="../../../public/img/riskmann_icono_color.png" alt="" width="38px"
            class="d-inline-block align-text-center" />
          <blockquote class="blockquote mt-2 text-primary float-end">
            <p class="mb-0 fw-normal">| RiskMann</p>
          </blockquote>
        </h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body justify-content-start">
        <ul class="list-unstyled ps-0" id="navegacion">
          <!-- USUARIO - LOGIN -->
          <template v-if="usuario.id">
            <div class="card bg-light">
              <div class="card-body d-flex align-items-center">
                <div class="me-2">
                  <img class="shadow-sm rounded-pill border border-light" :src="usuario.foto
                    ? usuario.foto
                    : $store.state.imagenes.defecto.foto
                    " alt="" :width="esModoSinConexion ? 60 : 88" />
                </div>
                <p class="card-text">
                  <span v-if="usuario.nombre" class="limit-text" :title="usuario.nombre">
                    {{ usuario.nombre }} <br />
                  </span>
                  <span class="limit-text fw-bold" :title="usuario.cargo">
                    {{ usuario.cargo }}
                  </span>
                  <router-link v-if="!esModoSinConexion" :to="{ name: 'UsuarioMiPerfilEditar' }">
                    <li class="text-primary" data-bs-dismiss="offcanvas" aria-label="Close">
                      Editar Perfil
                    </li>
                  </router-link>
                  <!-- Donde muchos la buscan primero: lleva directo a «Seguridad y acceso» de Editar perfil. Ya
                       en esa página, reemplaza la entrada del historial: al guardar, «volver» no debe caer en ella. -->
                  <router-link v-if="!esModoSinConexion"
                    :to="{ name: 'UsuarioMiPerfilEditar', query: { seccion: 'seguridad' } }"
                    :replace="$route.name === 'UsuarioMiPerfilEditar'">
                    <li class="text-primary" data-bs-dismiss="offcanvas" aria-label="Close">
                      Cambiar Contraseña
                    </li>
                  </router-link>
                  <router-link v-if="!esModoSinConexion" :to="{ name: 'SolicitudesVinculacion' }">
                    <li class="text-primary" data-bs-dismiss="offcanvas" aria-label="Close">
                      Solicitudes de Vinculación
                    </li>
                  </router-link>
                </p>
              </div>
              <li class="border-top ms-0 me-0 my-0"></li>
              <div class="card-body">
                <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
                  <a href="https://riskmann-manual.web.app/" target="_blank" rel="noopener noreferrer"
                    class="btn btn-outline-primary w-100 text-start rounded">
                    <i class="fas fa-book"></i> | Manual de Uso
                  </a>
                </li>
                <li v-if="!esModoSinConexion" class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
                  <router-link :to="{ name: 'CapacitacionGratuita' }"
                    class="btn btn-outline-success w-100 text-start rounded">
                    <i class="fas fa-play-circle"></i> | Resumen del En Vivo
                  </router-link>
                </li>
                <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
                  <router-link :to="{ name: 'SoporteTecnico' }" class="btn w-100 text-start rounded" :class="{
                    'btn-outline-danger fw-bold': $route.name === 'SoporteTecnico',
                    'btn-danger': $route.name != 'SoporteTecnico',
                  }">
                    <i class="fas fa-headset"></i> | Soporte Técnico
                  </router-link>
                </li>
                <button @click="cerrarSesion()" class="btn btn-dark w-100 text-start rounded"
                  data-bs-dismiss="offcanvas" aria-label="Close" :disabled="esModoSinConexion">
                  <i class="fa fa-sign-out"></i> | Cerrar Sesión
                </button>
              </div>
            </div>
            <li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <router-link :to="{ name: 'Inicio' }" class="btn btn-lg w-100 text-start rounded" :class="{
                'btn-outline-primary fw-bold': $route.name === 'Inicio',
                'btn-primary': $route.name != 'Inicio',
              }">
                <i class="fas fa-home"></i> | Inicio
              </router-link>
            </li>
            <!-- AUDITOR SOFU: hace inspecciones en cualquier espacio de trabajo sin estar vinculado (src/utils/auditorSofu.js) -->
            <li v-if="esAuditor && !esModoSinConexion" class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <router-link :to="{ name: 'SeguridadVialInspeccionesCargarPapel' }"
                class="btn btn-lg w-100 text-start rounded" :class="{
                  'btn-outline-primary fw-bold': $route.name === 'SeguridadVialInspeccionesCargarPapel',
                  'btn-primary': $route.name != 'SeguridadVialInspeccionesCargarPapel',
                }">
                <i class="fas fa-clipboard-check"></i> | Inspección de auditoría
              </router-link>
            </li>
            <!-- SUPER ADMINISTRADOR -->
            <template v-if="usuario.id === 'b0iLGWGc6AcwqsyoH2VcyZTMNzL2'">
              <li class="border-top ms-0 me-0 my-2"></li>
              <li class="mb-1">
                <button type="button" class="btn btn-primary w-100 text-start collapsed" data-bs-toggle="collapse"
                  data-bs-target="#panel-administrativo-collapse" aria-expanded="false" :disabled="esModoSinConexion">
                  <i class="fas fa-cogs"></i> | Panel Administrativo
                </button>
                <div class="collapse" :class="{
                  show:
                    ($route.name === 'PanelAdministrativoNovedades' && !esModoSinConexion) ||
                    ($route.name === 'PanelAdministrativoEventos' && !esModoSinConexion) ||
                    ($route.name === 'PanelAdministrativoDashboard' && !esModoSinConexion)
                }" data-bs-parent="#navegacion" id="panel-administrativo-collapse" data-bs-dismiss="offcanvas"
                  aria-label="Close">
                  <div class="list-group border-radius-10 mt-1">
                    <router-link :to="{ name: 'PanelAdministrativoDashboardV2' }"
                      class="list-group-item list-group-item-action" :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'PanelAdministrativoDashboardV2',
                      }">
                      Dashboard
                    </router-link>
                    <router-link :to="{ name: 'PanelAdministrativoEventos' }"
                      class="list-group-item list-group-item-action" :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'PanelAdministrativoEventos',
                      }">
                      Eventos
                    </router-link>
                    <router-link :to="{ name: 'PanelAdministrativoNovedades' }"
                      class="list-group-item list-group-item-action" :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'PanelAdministrativoNovedades',
                      }">
                      Novedades
                    </router-link>
                    <router-link :to="{ name: 'PanelAdministrativoSeguridadVialFormatos' }"
                      class="list-group-item list-group-item-action" :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'PanelAdministrativoSeguridadVialFormatos',
                      }">
                      Formatos de Seguridad Vial
                    </router-link>
                    <router-link :to="{ name: 'PanelAdministrativoConsolaActividad' }"
                      class="list-group-item list-group-item-action" :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'PanelAdministrativoConsolaActividad',
                      }">
                      Consola de Actividad
                    </router-link>
                  </div>
                </div>
              </li>
            </template>
            <!-- ADMINISTRACIÓN -->
            <template
              v-if="usuario && usuario.privilegios && usuario.privilegios.panelAdministrativo && usuario.privilegios.panelAdministrativo.ver">
              <li class="border-top ms-0 me-0 my-2"></li>
              <li class="mb-1">
                <button type="button" class="btn btn-primary w-100 text-start collapsed" data-bs-toggle="collapse"
                  data-bs-target="#administracion-collapse" aria-expanded="false" :disabled="esModoSinConexion">
                  <i class="fas fa-chart-pie"></i> | Administración
                </button>
                <div class="collapse" :class="{
                  show:
                    ($route.name === 'AdministracionInicio' && !esModoSinConexion) ||
                    ($route.name === 'AdministracionFlotaEmpresarial' && !esModoSinConexion) ||
                    ($route.name === 'AdministracionPlantillaConductores' && !esModoSinConexion)
                }" data-bs-parent="#navegacion" id="administracion-collapse" data-bs-dismiss="offcanvas"
                  aria-label="Close">
                  <div class="list-group border-radius-10 mt-1">
                    <router-link :to="{ name: 'AdministracionInicio' }" class="list-group-item list-group-item-action"
                      :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'AdministracionInicio',
                      }">
                      Panel de Control
                    </router-link>
                    <router-link :to="{ name: 'AdministracionFlotaEmpresarial' }"
                      class="list-group-item list-group-item-action" :class="{
                        'bg-light border border-primary fw-bold':
                          $route.name === 'AdministracionFlotaEmpresarial',
                      }">
                      Flota Empresarial
                    </router-link>
                    <router-link :to="{ name: 'AdministracionPlantillaConductores' }"
                      class="list-group-item list-group-item-action"
                      :class="{ 'bg-light border border-primary fw-bold': $route.name === 'AdministracionPlantillaConductores' }">
                      Plantilla de Conductores
                    </router-link>
                  </div>
                </div>
              </li>
            </template>
            <!-- ESPACIOS DE TRABAJO -->
            <li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1">
              <button type="button" class="btn btn-primary w-100 text-start collapsed" data-bs-toggle="collapse"
                data-bs-target="#empresa-collapse" aria-expanded="false" :disabled="esModoSinConexion">
                <i class="fas fa-building"></i> | Espacios de Trabajo
              </button>
              <div class="collapse" :class="{
                show:
                  ($route.name === 'EmpresasInicio' && !esModoSinConexion) ||
                  ($route.name === 'EmpresaDatosGenerales' && !esModoSinConexion) ||
                  ($route.name === 'EmpresasMisEmpresasCrearEmpresa' && !esModoSinConexion) ||
                  ($route.name === 'EmpresasMisEmpresas' && !esModoSinConexion) ||
                  ($route.name === 'EmpresasVinculaciones' && !esModoSinConexion) ||
                  ($route.name === 'EmpresasGestionDocumental' && !esModoSinConexion) ||
                  ($route.name === 'EmpresasMisRegionales' && !esModoSinConexion) ||
                  ($route.name === 'EmpresasProfesiogramas' && !esModoSinConexion),
              }" data-bs-parent="#navegacion" id="empresa-collapse" data-bs-dismiss="offcanvas" aria-label="Close">
                <div class="list-group border-radius-10 mt-1">
                  <router-link :to="{ name: 'EmpresasInicio' }" class="list-group-item list-group-item-action" :class="{
                    'bg-light border border-primary fw-bold':
                      $route.name === 'EmpresasInicio',
                  }">
                    Inicio
                  </router-link>
                  <router-link :to="{ name: 'EmpresaDatosGenerales' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresaDatosGenerales',
                    }">
                    Datos Generales
                  </router-link>
                  <router-link :to="{ name: 'EmpresasMisEmpresasCrearEmpresa' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasMisEmpresasCrearEmpresa',
                    }">
                    Crear Espacio de Trabajo
                  </router-link>
                  <router-link :to="{ name: 'EmpresasMisEmpresas' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasMisEmpresas',
                    }">
                    Mis Espacios de Trabajo
                  </router-link>
                  <router-link :to="{ name: 'EmpresasVinculaciones' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasVinculaciones',
                    }">
                    Vinculaciones
                  </router-link>
                  <router-link :to="{ name: 'EmpresasGestionDocumental' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasGestionDocumental',
                    }">
                    Gestión Documental
                  </router-link>
                  <router-link :to="{ name: 'EmpresasProfesiogramas' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasProfesiogramas',
                    }">
                    Profesiogramas
                  </router-link>
                  <!-- <router-link :to="{ name: 'EmpresasMisRegionales' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasMisRegionales',
                    }">
                    Mis Regionales
                  </router-link>
                  <a @click="$store.state.enDesarrollo()" style="cursor: pointer;"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'EmpresasMisRegionales',
                    }">
                    Mis Regionales
                  </a>-->
                </div>
              </div>
            </li>
            <!-- CONTROL DE PERSONAL -->
            <!--<li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1">
              <button @click="$store.state.enDesarrollo()" type="button"
                class="btn btn-primary w-100 text-start collapsed" data-bs-toggle="collapse"
                data-bs-target="#control-personal-collapse" aria-expanded="false">
                <i class="fas fa-table"></i> | Control de Personal
              </button>
              <div class="collapse" :class="{
                show:
                  $route.name === 'ControlPersonalInicio' ||
                  $route.name === 'ControlDiario' ||
                  $route.name === 'RegistroManual' ||
                  $route.name === 'RegistroQR' ||
                  $route.name === 'Estadisticas' ||
                  $route.name === 'AusentismoLaboral',
              }" data-bs-parent="#navegacion" id="control-personal-collapse" data-bs-dismiss="offcanvas"
                aria-label="Close">
                <div class="list-group border-radius-10 mt-1">
                  <router-link :to="{ name: 'ControlPersonalInicio' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'ControlPersonalInicio',
                    }">
                    Inicio
                  </router-link>
                  <router-link :to="{ name: 'RegistroManual' }" class="list-group-item list-group-item-action" :class="{
                    'bg-light border border-primary fw-bold':
                      $route.name === 'RegistroManual',
                  }">
                    Registro Manual
                  </router-link>
                  <router-link :to="{ name: 'RegistroQR' }" :class="{
                    'bg-light border border-primary fw-bold':
                      $route.name === 'RegistroQR',
                  }" class="list-group-item list-group-item-action">
                    Lector QR
                  </router-link>
                  <router-link :to="{ name: 'ControlDiario' }" class="list-group-item list-group-item-action" :class="{
                    'bg-light border border-primary fw-bold':
                      $route.name === 'ControlDiario',
                  }">
                    Historial Diario
                  </router-link>
                  <router-link :to="{ name: 'Estadisticas' }" class="list-group-item list-group-item-action" :class="{
                    'bg-light border border-primary fw-bold':
                      $route.name === 'Estadisticas',
                  }">
                    Estadísticas
                  </router-link>
                  <router-link :to="{ name: 'AusentismoLaboral' }" class="list-group-item list-group-item-action" :class="{
                    'bg-light border border-primary fw-bold':
                      $route.name === 'AusentismoLaboral',
                  }">
                    Ausentismo Laboral
                  </router-link>
                </div>
              </div>
            </li>-->
            <!-- CAPACITACIONES -->
            <!--  <li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1">
              <button type="button" class="btn btn-primary w-100 text-start collapsed" data-bs-toggle="collapse"
                data-bs-target="#capacitaciones-collapse" aria-expanded="false" :disabled="esModoSinConexion">
                <i class="fas fa-chalkboard-teacher"></i> | Capacitaciones
              </button>
              <div class="collapse" :class="{
                show:
                  ($route.name === 'CapacitacionesInicio' && !esModoSinConexion) ||
                  ($route.name === 'Capacitaciones' && !esModoSinConexion) ||
                  ($route.name === 'CapacitacionesEstadisticas' && !esModoSinConexion),
              }" data-bs-parent="#navegacion" id="capacitaciones-collapse" data-bs-dismiss="offcanvas"
                aria-label="Close">
                <div class="list-group border-radius-10 mt-1">
                  <router-link :to="{ name: 'CapacitacionesInicio' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'CapacitacionesInicio',
                    }">
                    Inicio
                  </router-link>
                  <router-link :to="{ name: 'Capacitaciones' }" v-if="usuario && usuario.privilegios && usuario.privilegios.capacitaciones && usuario.privilegios.capacitaciones.ver"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'Capacitaciones',
                    }">
                    Capacitaciones
                  </router-link>
                  <router-link :to="{ name: 'CapacitacionesNuevo' }" v-if="usuario && usuario.privilegios && usuario.privilegios.capacitaciones && usuario.privilegios.capacitaciones.crear"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'CapacitacionesNuevo',
                    }">
                    Creador de Capacitaciones
                  </router-link>
                  <router-link :to="{ name: 'CapacitacionesEstadisticas' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'CapacitacionesEstadisticas',
                    }" v-if="usuario && usuario.privilegios && usuario.privilegios.capacitaciones && usuario.privilegios.capacitaciones.estadisticas">
                    Estadísticas
                  </router-link>
                  <a @click="$store.state.enDesarrollo()" style="cursor: pointer;"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'CapacitacionesEstadisticas',
                    }" v-if="usuario && usuario.privilegios && usuario.privilegios.capacitaciones && usuario.privilegios.capacitaciones.estadisticas">
                    Estadísticas
                  </a>
                </div>
              </div>
            </li> -->
            <!-- SEGURIDAD VIAL -->
            <li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1">
              <button type="button" class="btn btn-primary w-100 text-start rounded collapsed" data-bs-toggle="collapse"
                data-bs-target="#seguridadvial-collapse" aria-expanded="false">
                <i class="fas fa-road"></i> | Seguridad Vial
              </button>
              <div class="collapse" :class="{
                show:
                  $route.name === 'SeguridadVialInicio' ||
                  $route.name === 'SeguridadVialInspecciones' ||
                  $route.name === 'SeguridadVialMisInspecciones' ||
                  $route.name === 'SeguridadVialAptitudesFisicas' ||
                  $route.name === 'SeguridadVialInspeccionesOffline' ||
                  $route.name === 'SeguridadVialAptitudesFisicasOffline' ||
                  ($route.name === 'SeguridadVialConductoresActivos' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialVehiculosActivos' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialMantenimientos' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialInfografias' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialSiniestros' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialFormatos' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialCuestionarios' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialNovedades' && !esModoSinConexion) ||
                  ($route.name === 'SeguridadVialInformeAutogestion' && !esModoSinConexion),
              }" data-bs-parent="#navegacion" id="seguridadvial-collapse" data-bs-dismiss="offcanvas"
                aria-label="Close">
                <div class="list-group border-radius-10 mt-1">
                  <router-link :to="{ name: 'SeguridadVialInicio' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialInicio',
                    }">
                    Inicio
                  </router-link>
                  <router-link
                    v-if="usuario.idEmpresaSeleccionada && (usuario.idEmpresaSeleccionada === 'eeIA3a4jDGQ6m0thgGBS' || usuario.idEmpresaSeleccionada === '6DECDG5bFiLX6hJNRak8')"
                    :to="{ name: esModoSinConexion ? 'SeguridadVialPlanesDesplazamientosOffline' : 'SeguridadVialPlanesDesplazamientos' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialPlanesDesplazamientosOffline' || $route.name === 'SeguridadVialPlanesDesplazamientos',
                    }">
                    Planes de Desplazamientos Terrestres
                  </router-link>
                  <router-link
                    :to="{ name: esModoSinConexion ? 'SeguridadVialAptitudesFisicasOffline' : 'SeguridadVialAptitudesFisicas' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialAptitudesFisicasOffline' || $route.name === 'SeguridadVialAptitudesFisicas'
                    }">
                    Aptitudes Físicas
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialInfografias' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialInfografias',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Infografías
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialConductoresActivos' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialConductoresActivos',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Conductores
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialVehiculosActivos' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialVehiculosActivos',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Vehículos
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialFormatos' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialFormatos',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Formatos
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialCuestionarios' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialCuestionarios',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Cuestionarios
                  </router-link>
                  <router-link
                    :to="{ name: esModoSinConexion ? 'SeguridadVialInspeccionesOffline' : (inspeccionesPropias ? 'SeguridadVialMisInspecciones' : 'SeguridadVialInspecciones') }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialInspeccionesOffline' || $route.name === 'SeguridadVialInspecciones' || $route.name === 'SeguridadVialMisInspecciones',
                    }">
                    {{ inspeccionesPropias && !esModoSinConexion ? 'Mis inspecciones' : 'Inspecciones' }}
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialMantenimientos' }"
                    class="list-group-item list-group-item-action" :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialMantenimientos',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Mantenimientos
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialSiniestros' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialSiniestros',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Siniestralidad Vial
                  </router-link>
                  <router-link :to="{ name: 'SeguridadVialNovedades' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialNovedades',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Justificaciones
                  </router-link>
                  <!-- Informe Anual de Autogestión del PESV (issue #1187): solo con el privilegio de verlo; requiere conexión.
                       En desarrollo, con el modo muestra activo, aparece también sin el privilegio. -->
                  <router-link
                    v-if="modoMuestraInformePesv || (usuario && usuario.privilegios && usuario.privilegios.seguridadVial && usuario.privilegios.seguridadVial.informeAutogestion && usuario.privilegios.seguridadVial.informeAutogestion.ver)"
                    :to="{ name: 'SeguridadVialInformeAutogestion' }" class="list-group-item list-group-item-action"
                    :class="{
                      'bg-light border border-primary fw-bold':
                        $route.name === 'SeguridadVialInformeAutogestion',
                      'opacity cursor_none': esModoSinConexion
                    }">
                    Informe Anual de Autogestión
                  </router-link>
                </div>
              </div>
            </li>
            <!-- PLAN ANUAL SG-SST -->
            <li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <a href="#" @click.prevent="irPlanAnualSGSST" class="btn btn-lg w-100 text-start rounded btn-primary"
                :class="{
                  'opacity cursor_none': esModoSinConexion
                }">
                <i class="fas fa-shield-alt"></i> | Plan Anual SG-SST
              </a>
            </li>
            <!-- ACTUALIZACIONES -->
            <li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <router-link :to="{ name: 'Novedades' }" class="btn btn-lg w-100 text-start rounded" :class="{
                'btn-outline-primary fw-bold': $route.name === 'Novedades' || $route.name === 'NovedadesConsultar',
                'btn-primary': $route.name !== 'Novedades' && $route.name !== 'NovedadesConsultar',
                'opacity cursor_none': esModoSinConexion
              }">
                <i class="fas fa-newspaper"></i> | Actualizaciones
              </router-link>
            </li>
            <!-- RUTOGRAMAS -->
            <!--<li class="border-top ms-0 me-0 my-2"></li>
            <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <router-link :to="{ name: 'RutogramasOffline' }" class="btn btn-lg w-100 text-start rounded" :class="{
                'btn-outline-primary fw-bold': $route.name === 'RutogramasOffline' || $route.name === 'RutogramasOnline',
                'btn-primary': $route.name != 'RutogramasOffline' && $route.name != 'RutogramasOnline',
              }">
                <i class="fas fa-map-marked-alt"></i> | Rutogramas
              </router-link>
            </li>-->
          </template>
          <!-- USUARIIO - LOGOUT -->
          <template v-else>
            <li class="mb-1">
              <router-link :to="{ name: 'Login' }">
                <button class="btn w-100 text-start rounded" :class="{
                  'btn-outline-primary fw-bold': $route.name === 'Login',
                  'btn-primary': $route.name != 'Login',
                }" data-bs-dismiss="offcanvas" aria-label="Close">
                  <i class="fas fa-user"></i> | Ingresar
                </button>
              </router-link>
            </li>
            <li class="mb-1">
              <router-link :to="{ name: 'Registrarse' }">
                <button class="btn w-100 text-start rounded" :class="{
                  'btn-outline-primary fw-bold':
                    $route.name === 'Registrarse',
                  'btn-primary': $route.name != 'Registrarse',
                }" data-bs-dismiss="offcanvas" aria-label="Close">
                  <i class="fas fa-user-plus"></i> | Registrarse
                </button>
              </router-link>
            </li>
            <li class="border-top my-3"></li>
            <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <a href="https://riskmann-manual.web.app/" target="_blank" rel="noopener noreferrer"
                class="btn btn-outline-primary w-100 text-start rounded">
                <i class="fas fa-book"></i> | Manual de Uso
              </a>
            </li>
            <li class="mb-1" data-bs-dismiss="offcanvas" aria-label="Close">
              <router-link :to="{ name: 'SoporteTecnico' }" class="btn w-100 text-start rounded" :class="{
                'btn-outline-danger fw-bold': $route.name === 'SoporteTecnico',
                'btn-danger': $route.name != 'SoporteTecnico',
              }">
                <i class="fas fa-headset"></i> | Soporte Técnico
              </router-link>
            </li>
          </template>
        </ul>
      </div>
      <div class="offcanvas_footer border bg-light p-2">
        <div class="d-flex gap-1" :class="{ 'justify-content-between': !esModoSinConexion }">
          <div v-if="!esModoSinConexion" data-bs-dismiss="offcanvas" aria-label="Close">
            <router-link :to="{ name: 'Novedades' }" class="text-primary">
              Actualizaciones
            </router-link>
          </div>
          <div>
            <p>[{{ $store.state.version }}]</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import {
  collection,
  doc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { stopAllTrackers, clearTrackers } from "@/plugins/trackerManager/trackerManager";
import { Offcanvas } from "bootstrap";
import Notificaciones from "./Notificaciones/Notificaciones.vue";
import Swal from "sweetalert2";
import _ from "lodash";
import localforage from "localforage";
import { MODO_MUESTRA as MODO_MUESTRA_INFORME_PESV } from "@/services/informePesv/modoMuestra";
import { esAuditorSofu } from "@/utils/auditorSofu";
export default {
  name: "Navbar",

  components: {
    Notificaciones,
  },

  data() {
    return {
      notificacionesListener: null,
      usuario: {
        id: "",
        foto: "",
        cargo: "",
        nombre: "",
        idEmpresaSeleccionada: "",
        idUsuarioEmpresa: "",
        privilegios: new this.$store.state.privilegios(),
        notificaciones: 0,
      },
      esNotificaciones: false,
      esModoSinConexion: false,
      esAuditor: false,
      privilegiosCargados: false,
      // Solo desarrollo: con el modo muestra del informe PESV, el enlace aparece sin el privilegio (ver modoMuestra.js).
      modoMuestraInformePesv: MODO_MUESTRA_INFORME_PESV,
    };
  },

  computed: {
    // Quien no ve todas las inspecciones del espacio (sin el privilegio de eliminar) entra directo a las suyas
    inspeccionesPropias() {
      const privilegios = this.usuario.privilegios;
      const inspecciones = privilegios && privilegios.seguridadVial ? privilegios.seguridadVial.inspecciones : null;
      return this.privilegiosCargados && !(inspecciones && inspecciones.eliminar);
    },
  },

  async created() {
    this.esModoSinConexion = await this.$store.state.obtenerModoSinConexion();
    if (this.esModoSinConexion) {
      const obtenerUsuario = await localforage.getItem(this.$store.state.colecciones.localforage.usuarios.local);
      if (obtenerUsuario) {
        this.usuario.id = obtenerUsuario.id;
        this.usuario.nombre = `${obtenerUsuario.nombre} ${obtenerUsuario.apellido}`;
        this.usuario.idEmpresaSeleccionada = obtenerUsuario.preferencias.idEmpresaSeleccionada;
      }
    } else {
      onAuthStateChanged(auth, async () => {
        const usuario = auth.currentUser;
        this.esAuditor = await esAuditorSofu();
        if (usuario) {
          const usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
          if (usuarioDB) {
            await this.obtenerUsuario(usuarioDB.id);
            await this.obtenerNotificaciones(usuarioDB.id);
            if (usuarioDB.preferencias.idEmpresaSeleccionada) {
              const obtenerVinculacion = await this.$store.state.obtenerVinculacion(
                usuarioDB.preferencias.idEmpresaSeleccionada,
                usuarioDB.id
              );
              if (obtenerVinculacion.id) {
                await this.obtenerVinculacion(obtenerVinculacion.id);
              }
              if (obtenerVinculacion.privilegios) {
                // Realizamos un merge profundo con la estructura base para garantizar resiliencia
                // si la base de datos contiene un objeto de privilegios parcial o en versión anterior.
                this.usuario.privilegios = _.merge(
                  new this.$store.state.privilegios().definir(),
                  obtenerVinculacion.privilegios
                );
                this.privilegiosCargados = true;
              }
              if (obtenerVinculacion.cargo) {
                this.usuario.cargo = obtenerVinculacion.cargo;
              }
            }
          }
        }
      });
    }
  },

  beforeUnmount() {
    // Limpiamos el listener al destruir el componente para evitar fugas de memoria
    if (this.notificacionesListener) {
      this.notificacionesListener();
    }
  },

  methods: {
    async obtenerUsuario(id) {
      onSnapshot(doc(db, "riskmann_usuarios", id), async (doc) => {
        this.usuario.id = doc.data().id;
        this.usuario.foto = doc.data().foto.url;
        this.usuario.nombre = doc.data().nombre + " " + doc.data().apellido;
        if (doc.data().preferencias.idEmpresaSeleccionada) {
          this.usuario.idEmpresaSeleccionada = doc.data().preferencias.idEmpresaSeleccionada;
          let empresa = await this.$store.state.obtenerEmpresa(
            this.usuario.idEmpresaSeleccionada
          );
          if (empresa) {
            this.usuario.idUsuarioEmpresa = empresa.idUsuario;
          }
        } else {
          this.usuario.idEmpresaSeleccionada = "";
          this.usuario.cargo = "";
          this.usuario.idUsuarioEmpresa = "";
        }
      });
    },

    async obtenerVinculacion(id) {
      onSnapshot(doc(db, "riskmann_trabajadores", id), async (doc) => {
        const datos = doc.data();
        if (datos && datos.privilegios) {
          const privilegiosDB = _.merge(
            new this.$store.state.privilegios().definir(),
            datos.privilegios
          );
          if (!_.isEqual(privilegiosDB, this.usuario.privilegios)) {
            Swal.fire({
              imageUrl: require("@/assets/img/general_alerta_ilustracion_privilegios_cambiados.webp"),
              imageWidth: 300,
              background: 'rgba(255, 255, 255)',
              backdrop: `rgba(0,0,0,0.7)`,
              title: '<h6 class="text-dark">Tus privilegios se han actualizado.</h6>',
              html: `<small style="font-size: 15pt;">Para aplicar los cambios, por favor, da clic en el siguiente botón.</small><br/>`,
              confirmButtonText: 'Entendido',
              customClass: {
                input: "rounded",
                confirmButton: "btn btn-primary btn-md fw-bold mb-2",
              },
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result.value) {
                this.$router.go(0);
              }
            })
          }
        }
      });
    },


    async obtenerNotificaciones(id) {
      // Si ya hay un listener activo para este usuario, no creamos otro
      if (this.notificacionesListener) {
        this.notificacionesListener();
      }

      const docRef = doc(
        db,
        "riskmann_metadata_firestore",
        "riskmann_notificaciones",
        "usuarios",
        id
      );

      // Guardamos la referencia para poder cancelarla luego
      this.notificacionesListener = onSnapshot(docRef, (docSnapshot) => {
        const datos = docSnapshot.data();
        // Si el documento existe, tomamos el valor de noLeidas, de lo contrario es 0
        const noLeidas = datos && typeof datos.noLeidas === "number" ? datos.noLeidas : 0;
        // Evitamos valores negativos y lo asignamos
        this.usuario.notificaciones = noLeidas < 0 ? 0 : noLeidas;
      }, (error) => {
        console.error("Error en el listener de metadatos de notificaciones:", error);
      });
    },

    abrirOffCanvas() {
      this.esNotificaciones = true;
      setTimeout(() => {
        new Offcanvas("#notificacionNavbar", {
          backdrop: true,
        }).show();
      }, 25);
    },

    cerrarOffCanvas(data) {
      this.esNotificaciones = data;
    },

    cerrarSesion() {
      Swal.fire({
        icon: "info",
        title: "<h6 class='text-dark'>¿Deseas cerrar la sesión?</h6>",
        background: "rgba(255, 255, 255)",
        backdrop: `rgba(0,0,0,0.7)`,
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Cerrar Sesión",
        cancelButtonText: "Cancelar",
        reverseButtons: false,
        customClass: {
          popup: "swal-radius",
          confirmButton: "btn btn-primary btn-md fw-bold me-2 mb-3",
          cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.$isLoading(true);
            this.usuario.id = null;
            await stopAllTrackers("logout");
            clearTrackers();
            await auth.signOut();
            this.$isLoading(false);
            await this.$store.state.alerta(
              "success",
              "Su sesión se ha cerrado correctamente. Hasta pronto."
            );
            this.$router.replace({ name: 'Entrada' });
          } catch (error) {
            console.error("Error al cerrar sesión:", error);
            throw error;
          }
        }
      });
    },

    irPlanAnualSGSST() {
      if (this.esModoSinConexion) return;

      if (
        this.usuario &&
        this.usuario.privilegios &&
        this.usuario.privilegios.panelAdministrativo &&
        this.usuario.privilegios.panelAdministrativo.ver
      ) {
        window.open("https://riskmann-sgsst-dev.web.app/login", "_blank");
      } else {
        Swal.fire({
          icon: "warning",
          title: "<h5 class='text-dark fw-bold'>Acceso Restringido</h5>",
          text: "No cuentas con los privilegios necesarios para acceder al módulo Plan Anual SG-SST.",
          background: "rgba(255, 255, 255)",
          backdrop: `rgba(0,0,0,0.7)`,
          buttonsStyling: false,
          confirmButtonText: "Entendido",
          customClass: {
            popup: "swal-radius",
            confirmButton: "btn btn-primary btn-md fw-bold px-4 py-2",
          },
          allowOutsideClick: true,
          allowEscapeKey: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.navbar {
  border-bottom: 1px solid rgba(136, 136, 136, 0.2);
}

.limit-text {
  font-size: 11pt;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.offcanvas-header {
  padding: 0px;
}

.offcanvas_footer {
  position: sticky;
  bottom: 1;
  z-index: 1;
}

.offcanvas_footer p {
  margin-bottom: 0px;
}

.border-radius-10 {
  border-radius: 0px !important;
  -webkit-border-bottom-right-radius: 10px !important;
  -webkit-border-bottom-left-radius: 10px !important;
  -moz-border-radius-bottomright: 10px !important;
  -moz-border-radius-bottomleft: 10px !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.fas.fa-home {
  margin-right: 3px;
}

.fas.fa-building {
  margin-right: 4px;
  margin-left: 7px;
}

.fas.fa-cogs {
  margin-right: 3px;
  margin-left: 2px;
}

.fas.fa-chalkboard-teacher {
  margin-right: 3px;
  margin-left: 2px;
}

.fas.fa-road {
  margin-right: 3px;
  margin-left: 3px;
}

.fas.fa-user-times {
  margin-right: 3px;
  margin-left: 2px;
}

.fas.fa-user {
  margin-right: 4px;
  margin-left: 2px;
}

.fas.fa-table {
  margin-right: 4px;
  margin-left: 5px;
}

.fas.fa-chart-pie {
  margin-right: 4px;
  margin-left: 4px;
}

.fas.fa-map-marked-alt {
  margin-right: 1px;
}

.cursor_none {
  pointer-events: none;
}

.opacity {
  opacity: 0.6;
}
</style>